<template>
  <div class="app-container zhujue">
    <el-dialog
      title="申请施工单位"
      :close-on-click-modal="false"
      v-dialogDrag
      width="30%"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form">
        <el-form-item label="单位名称" :label-width="formLabelWidth">
          <el-input v-model="form.company_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" :label-width="formLabelWidth">
          <el-input v-model="form.unify_code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogF">确 定</el-button>
      </div>
    </el-dialog>
    <div
      style="
        padding:10px;
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
      "
    >
      <div style="display: flex">
        <el-button
          @click="shuaxin"
          type="info"
          icon="el-icon-refresh-right"
          class="anniu"
        ></el-button>
        <el-button
          size="mini"
          style="width: 100px;"
          class="anniu"
          type="primary"
          @click="handleClose"
          >申请施工单位</el-button
        >
      </div>
      <div style="display: flex; justify-content: space-around">
        <el-row style="display: flex; justify-content: flex-end;" class="mb8">
          <el-col :span="19" class="seach">
            <el-input
              v-model="weidaili_params.keywords"
              placeholder="请输入"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="sousuo"
            ></el-button>
          </el-col>
        </el-row>

      </div>
    </div>
    <el-row :gutter="10" class="mb8"> </el-row>
    <div class="weidaili">
      <el-table
        :data="daili_list"
        height="100%"
        class="table xtable"
        stripe
        border
        align="center"
        v-loading="loading"
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column
          label="序号"
          align="center"
          width="55"
          prop="company_id"
        />
        <el-table-column
          label="机构名称"
          align="center"
          prop="company_name"
          width="210"
        />
        <el-table-column
          label="联系人"
          align="center"
          prop="corporate_information"
        />
        <el-table-column
          label="联系电话"
          align="center"
          prop="corporate_phone"
        />
        <el-table-column
          label="统一社会信用代码"
          width="200"
          align="center"
          prop="unify_social_credit_code"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="handleUpdate(scope.row)">编辑</el-button> -->
            <el-button size="mini" type="danger" @click="handlesc(scope.row)"
              >取消代理</el-button
            >
            <el-button size="mini" type="" @click="dtails(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :page-sizes="[10, 20, 30]"
        :page-size="daili_params.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="daili_total"
      ></el-pagination>
    </div>

    <el-dialog
      title=""
      :visible.sync="open1"
      fullscreen
      width="100%"
      custom-class="infoDetail"
    >
      <el-tabs class="tac" tab-position="left">
        <el-tab-pane style="height: 100%" label="企业基础信息">
          <el-form
            :model="formLabelAlign"
            label-width="170px"
            :disabled="true"
            class="fromsBox"
          >
            <el-form-item label="公司名称 :">
              <el-input
                v-model="formLabelAlign.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人姓名 :">
              <el-input
                v-model="formLabelAlign.legal_person"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人联系方式 :">
              <el-input
                v-model="formLabelAlign.legal_person_telphone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人身份证号 :">
              <el-input
                v-model="formLabelAlign.legal_person_idcard"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人身份证 :">
              <img width="49%" height="150" src="" alt />
              <img width="49%" height="150" src="" alt />
            </el-form-item>
            <el-form-item label="统一社会信用代码 :">
              <el-input
                v-model="formLabelAlign.legal_person"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业性质 :">
              <el-input
                :value="formLabelAlign.type == 1 ? '公办' : '民办'"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业代码 :">
              <el-input
                v-model="formLabelAlign.credit_code"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业邮箱 :">
              <el-input
                v-model="formLabelAlign.credit_code"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业地址 :">
              <el-input
                v-model="formLabelAlign.credit_code"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="营业执照 :">
              <img width="49%" height="150" src="" alt />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane style="height: 100%" label="企业开票信息">
          <el-form
            :model="formLabelAlign"
            label-width="170px"
            :disabled="true"
            class="fromsBox"
          >
            <el-form-item label="基本户存款账户编号 :">
              <el-input
                v-model="formLabelAlign.legal_person_telphone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址 :">
              <el-input
                :value="formLabelAlign.type == 1 ? '公办' : '民办'"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行 :">
              <el-input
                v-model="formLabelAlign.legal_person_idcard"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="账户 :">
              <el-input
                v-model="formLabelAlign.credit_code"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane style="height: 100%" label="企业快递地址">
          <div class="left">
            <div class="conter">
              <el-card class="box-card">
                <div>
                  <span>公司名称</span>
                  <span>联系方式</span>
                </div>
                <div>收货地址</div>
              </el-card>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
// import {
//   listType,
//   getType,
//   delType,
//   addType,
//   updateType
// } from "../../api/system/type";
import { weidaili, daili, quxiao } from "@/api/system/agenciesName.js";
import { shenqing, company_detail } from "@/api/system/applicationAgent.js";
export default {
  name: "Type",
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "140px",
      activeName: "first",
      // 未代理参数
      weidaili_params: {
        offset: 0,
        limit: 10,
        keywords: ""
      },
      weidaili_search: "",
      weidaili_total: null,
      // 代理参数
      daili_params: {
        offset: 0,
        limit: 10,
        keywords: ""
      },
      daili_search: "",
      daili_total: null,
      weidaili_list: [],
      daili_list: [],
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      tableData: [],
      // 字典类型表格数据
      typeList: [
        {
          createBy: "admin",
          createTime: "2022-08-01 12:01:35",
          dictId: 1,
          dictName: "用户性别",
          dictType: "sys_user_sex",
          params: {},
          remark: "用户性别列表",
          searchValue: null,
          status: "0",
          updateBy: null,
          updateTime: null
        }
      ],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        user_id: 3,
        // pageNum: 1,
        // pageSize: 10,
        // dictName: null,
        // dictType: null,
        // status: null,
        offset: 0,
        limit: 10,
        keywords: ""
      },
      // 表单参数
      form: { company_name: "", unify_code: "" },
      formLabelAlign: {
        name: "namne",
        legal_person: "legal_person",
        legal_person_telphone: "legal_person_telphone",
        type: "type",
        legal_person_idcard: "legal_person_idcard",
        credit_code: "credit_code"
      },
      // 表单校验
      rules: {},
      open1: false,
      loading:true,
    };
  },
  created() {
    // this.get_weidaili();
    this.get_daili();
  },
  methods: {
    sousuo() {},
    dialogF() {
      shenqing(this.form).then(res => {
        if (res.data.code == 1) {
          console.log("申请代理", res);
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.dialogFormVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    handleClose(done) {
      this.dialogFormVisible = true;
    },
    // 未代理
    get_weidaili() {
      weidaili(this.weidaili_params).then(res => {
        if (res.data.code == 1) {
          this.weidaili_list = res.data.data.rows;
          this.weidaili_total = res.data.data.total;
          console.log("未代理列表", this.weidaili_list);
        }
      });
    },
    handleSizeChange(val) {
      this.weidaili_params.limit = val;
      this.get_weidaili();
    },
    handleCurrentChange(val) {
      this.weidaili_params.offset = parseInt(val - 1) * 10;
      this.weidaili_params();
    },
    handleSearch() {
      this.weidaili_params.keywords = this.weidaili_search;
      this.get_weidaili();
    },
    handleSearch1() {
      this.daili_params.keywords = this.daili_search;
      this.get_daili();
    },
    shuaxin() {
        var that=this
      setTimeout(function() {
           that.get_daili();
      }, 500);
this.loading = true;
    },
    // 已经代理
    get_daili() {
     
      
      daili(this.daili_params).then(res => {
        if (res.data.code == 1) {
             this.loading = false;
          this.daili_list = res.data.data.rows;
          this.daili_total = res.data.data.total;
          console.log("已代理列表", this.daili_list);
        }
      });
    },

    handleSizeChange1(val) {
      this.daili_params.limit = val;
      this.get_daili();
    },
    handleCurrentChange1(val) {
      this.daili_params.offset = parseInt(val - 1) * 10;
      this.get_daili();
    },
    handleClick(row) {
      console.log(row);
    },
    handlesc(e) {
      var taht = this;
      console.log(e);
      this.$confirm("此操作将取消该代理公司, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          quxiao(e.company_id).then(res => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: "取消成功!"
              });
              this.get_daili();
            }
          });
        })
        .catch(() => {});
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        dictId: null,
        dictName: null,
        dictType: null,
        status: "0",
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      };
      // this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // this.queryParams.pageNum = 1;
    },
    /** 重置按钮操作 */
    resetQuery() {
      // this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log(selection);
    },
    /** 详情按钮操作 */
    dtails(val) {
      // this.open1 = true;
      this.$router.push({
        name: "detail",
        params: { company_id: val.company_id }
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {},
    /** 提交按钮 */
    submitForm() {
      //   this.$refs["form"].validate(valid => {
      //     if (valid) {
      //       if (this.form.dictId != null) {
      //         updateType(this.form).then(response => {
      //           this.$modal.msgSuccess("修改成功");
      //           this.open = false;
      //           this.getList();
      //         });
      //       } else {
      //         addType(this.form).then(response => {
      //           this.$modal.msgSuccess("新增成功");
      //           this.open = false;
      //           this.getList();
      //         });
      //       }
      //     }
      //   });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // const dictIds = row.dictId || this.ids;
      // this.$modal
      //   .confirm('是否确认删除字典类型编号为"' + dictIds + '"的数据项？')
      //   .then(function() {
      //     return;
      //     delType(dictIds);
      //   })
      //   .then(() => {
      //     this.getList();
      //     this.$modal.msgSuccess("删除成功");
      //   })
      //   .catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download(
      //   "system/type/export",
      //   {
      //     ...this.queryParams
      //   },
      //   `type_${new Date().getTime()}.xlsx`
      // );
    }
  }
};
</script>
<style scoped lang="scss">
.weidaili_head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search {
  float: right;
  width: 20%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;

  ::v-deep.el-input__inner {
    border: none !important;
  }

  .el-button {
    border: none;
  }
}

::v-deep.el-input__inner {
  border: none !important;
}

.weidaili {
  flex: 1;
  margin-bottom: 5px;
  overflow: hidden;
  padding:10px;
}

.block {
  width: 95%;
  padding-right: 5%;
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-end;
}

.showphoto {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.showphoto1 {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-tabs .el-tab-pane {
  height: 85vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.app-container {
  height: 100%;
  // padding: 20px;
  padding-bottom: 0px;
}

::v-deep .el-tabs__content {
  height: 100% !important;
}

.fromsBox {
  width: 70%;
  margin: 0 auto;
  .el-form-item {
    margin-bottom: 10px;
    margin-left: 20px;
  }
}

.title {
  font-weight: bold;
  margin-bottom: 10px;
}

.left {
  width: 70%;
  margin: 10px auto 0;
}

.conter {
  margin-left: 20px;
  // width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/view/agencies/information.vue